$(document).on('turbolinks:load', () => {
  $('.js-close-flash').on('click', function () {
    $(this).parent().remove();
  });
});
